/**
 * @module experience/landing/line-details
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */
// TODO: use foreach instead of for loop
/* tslint:disable: no-loop-func */
// interfaces
import { OrderSearchResults } from '@support/api/proxies/responses/api-2813.interface';
import { SelectItem } from '@experience/repdash/interfaces/select-item.interface';
import { OrdersFilteredByType } from '@experience/landing/common/interfaces/pending-orders-by-type.interface';
// constants
import { LINE_LANDING_CONSTANTS } from '@experience/landing/common/components/line-landing/line-landing.constants';

export class LinePendingOrdersModel {
  /**
   * stores orders filtered by type to be shown on UI
   */
  public ordersByType: SelectItem[] = [];
  /**
   * stores the response of pending orders received from API 2813
   */
  public ordersResponse: OrdersFilteredByType[];

  constructor(
    ordersResponse: OrderSearchResults[],
    orderTypesContent: string,
    hideOtherOrders?: boolean
  ) {
    this.ordersResponse = ordersResponse;
    this.filterOrders(this.ordersResponse, orderTypesContent, !hideOtherOrders);
  }
  /**
   * Method to filter orders based on each order type available
   * @param {OrderSearchResults[]} pendingOrders
   * @param showOthers: Pass false if you don't want any pending order other than given types
   * @returns void
   */
  public filterOrders(
    pendingOrders: OrderSearchResults[],
    orderTypesContent: string,
    showOthers: boolean
  ): void {
    const orderTypes = orderTypesContent ? JSON.parse(orderTypesContent) : '';
    const orderTypesLength: number = Object.keys(orderTypes).length;
    for (let orders = 0; orders < orderTypesLength; orders++) {
      const filteredOrders: OrderSearchResults[] = pendingOrders.filter(
        (order: OrderSearchResults) => {
          return order.orderType === Object.keys(orderTypes)[orders];
        }
      );
      if (filteredOrders.length) {
        const index: number = 0;
        const orderHeader = orderTypes[filteredOrders[index].orderType];
        this.setOrdersByOrderType(filteredOrders, orderHeader, filteredOrders[index].orderType);
      }
    }
    const unfilteredOrders: OrdersFilteredByType[] = this.ordersResponse.filter(
      (orders: OrdersFilteredByType) => {
        return !orders.isFiltered;
      }
    );
    if (unfilteredOrders.length && showOthers) {
      this.setOrdersByOrderType(unfilteredOrders);
    }
  }
  /**
   * Method to set orders under each order heading,
   * set property isFiltered to true for orders filtered, to fetch 'Other' orders
   * and club orders under same heading, if required
   * @param {(OrderSearchResults[] | OrdersFilteredByType[])} ordersFiltered
   * @param {string} [orderHeader]
   * @param {string} [orderType]
   * @returns void
   */
  public setOrdersByOrderType(
    ordersFiltered: OrderSearchResults[] | OrdersFilteredByType[],
    orderHeader?: string,
    orderType?: string
  ): void {
    if (orderType) {
      const orderResponseLength: number = this.ordersResponse.length;
      for (let index = 0; index < orderResponseLength; index++) {
        if (this.ordersResponse[index].orderType === orderType) {
          this.ordersResponse[index].isFiltered = true;
        }
      }
    }
    const orderData: SelectItem = {
      label: orderHeader ? orderHeader : LINE_LANDING_CONSTANTS.OTHER,
      value: ordersFiltered,
    };
    const orderAvailableWithHeader: SelectItem = this.ordersByType.find((order: SelectItem) => {
      return order.label === orderHeader;
    });
    if (orderAvailableWithHeader) {
      orderAvailableWithHeader.value = orderAvailableWithHeader.value.concat(orderData.value);
      this.ordersByType.forEach((item: SelectItem) => {
        if (item.label === orderHeader) {
          item = orderAvailableWithHeader;
        }
      });
    } else {
      this.ordersByType.push(orderData);
    }
  }
}
